import { useLocation } from 'react-router-dom';
import { isEmbedded } from 'embed';

export default function useEmbedMode() {
  const legacyEmbed =
    new URLSearchParams(useLocation().search).get('embed') === '1';
  return legacyEmbed || isEmbedded();
}
